/**
=========================================================
* Soft UI Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { makeStyles } from "@mui/styles";
import backgroundImageLogin from "assets/images/login-background-main.svg";

export default makeStyles(({ palette, typography, borders, functions, transitions }) => {
  const { white, alertColors } = palette;
  const { size, fontSizeRegular, fontWeightMedium } = typography;
  const { borderWidth, borderRadius } = borders;
  const { pxToRem, linearGradient } = functions;

  return {
    alert: {
      display: "flex",
      flexDirection: "column",
      width: "60rem",
      background: white.main,
      padding: pxToRem(16),
      marginBottom: pxToRem(16),
      borderRadius: borderRadius.md,
      fontSize: fontSizeRegular,
      fontWeight: fontWeightMedium,
      zIndex: 9999999,
      backgroundImage: `url(${backgroundImageLogin})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "245%",
      backgroundPosition: "0% 0",
    },

    alert_closeIcon: {
      color: white.main,
      fontSize: size.xl,
      padding: `${pxToRem(9)} ${pxToRem(6)} ${pxToRem(8)}`,
      marginLeft: pxToRem(40),
      fontWeight: fontWeightMedium,
      opacity: 0.5,
      cursor: "pointer",
      lineHeight: 0,
      transition: transitions.create("opacity", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),

      "&:hover": {
        opacity: 1,
      },
    },
  };
});
